import $axios from "../http/accessor";
import { auth } from "../endpoints/auth.endpoints";

const AuthService = {
  login: (data: FormData) => {
    return $axios.post(auth.login, data);
  },

  logout: () => {
    return $axios.post(auth.logout);
  },

  checkRefreshToken: (data: FormData) => {
    return $axios.post(auth.check_token, data);
  },
};

export default AuthService;
